import { useTranslation } from 'react-i18next';

import { BaseIngredientTabProps } from 'components/desktop/BaseIngredient/BaseIngredientComponent';
import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import TreeInput from 'components/desktop/_general/Input/TreeInput/TreeInput';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';
import * as BaseIngredientCategoryList from 'types/_general/Store/BaseIngredientCategoryList';

export const BaseIngredientCategoriesCard = ({
	state,
	handlers,
	data,
}: BaseIngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	const isBaseIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEBASEINGREDIENT,
	]);

	const getLabel = (): string => {
		if (!isBaseIngredientEditor) {
			if (state.categorieIds.length === 0) {
				return t('baseIngredient:NO_CATEGORIES');
			}
			return '';
		}
		return t('baseIngredient:CATEGORIES');
	};

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="baseingredient-categories-card"
			title={t('baseIngredient:CATEGORIES')}
			content={
				<>
					<div className="card-body">
						<TreeInput
							input={data.categories}
							setSelected={handlers.setCategories}
							selected={BaseIngredientCategoryList.getFromIds(
								data.categories,
								state.categorieIds
							)}
							errorKey={'Categories'}
							disabled={!isBaseIngredientEditor}
							label={getLabel()}
							noObjectsFoundText={t('_general:NO_CATEGORIES')}
						/>
					</div>
				</>
			}
		/>
	);
};
